/* eslint-disable default-case */
'use strict';

angular.module('app', [
  'ui.bootstrap',
  'ngRoute',
  'ngAnimate',
  'leaflet-directive',
  // 'duParallax',
  // 'scroll-animate-directive',
  'ngFileUpload',
  'rzModule',
  'ui.select',
  'ngSanitize',
  'slick',
  'LocalStorageModule',
  'vcRecaptcha',
  'gettext'
]);

angular.module('app')
  .run(function ($window, $rootScope, $location, $route, info, localStorageCheckService, gettextCatalog, selectedLanguage, uibPaginationConfig) {
    $rootScope.user = false;

    if (selectedLanguage === 'ach') {
      gettextCatalog.setCurrentLanguage('ach_UG');
    } else {
      gettextCatalog.setCurrentLanguage(selectedLanguage + '_' + selectedLanguage.toLocaleUpperCase());
    }

    var translationFileName = '';

    switch (selectedLanguage) {
    case 'de':
      translationFileName = 'angular-de.json';
      break;
    case 'fr':
      translationFileName = 'angular-fr.json';
      break;
    case 'it':
      translationFileName = 'angular-it.json';
      break;
    case 'es':
      translationFileName = 'angular-es.json';
      break;
    case 'nl':
      translationFileName = 'angular-nl.json';
      break;
    case 'ach':
      translationFileName = 'angular-ach.json';
      break;
    }

    if (selectedLanguage !== 'en') {
      gettextCatalog.loadRemote('/translations/' + translationFileName).then(function () {
        $rootScope.translationsUploaded = true;
      });
    }
    // check if localstorase is supported
    localStorageCheckService.check();

    var original = $location.path;
    $location.pathWithoutReload = function (path, reload) {
      if (reload === false) {
        var lastRoute = $route.current,
          un = $rootScope.$on('$locationChangeStart', function (event) {
            window.history.replaceState({}, path, path);
            event.preventDefault();

            $route.current = lastRoute;
            un();
          });
      }
      return original.apply($location, [path]);
    };

    (function (d) {
      var js,
        id = 'facebook-jssdk',
        ref = d.getElementsByTagName('script')[0];

      if (d.getElementById(id)) {
        return;
      }

      js = d.createElement('script');
      js.id = id;
      js.async = true;
      js.src = '//connect.facebook.net/en_US/sdk.js';

      ref.parentNode.insertBefore(js, ref);
    })(document);

    $window.fbAsyncInit = function () {
      FB.init({
        appId: info.facebookAppKey,
        status: true,
        cookie: true,
        xfbml: true,
        version: 'v2.3',
      });
    };
  })
  .config(function ($locationProvider, localStorageServiceProvider, $httpProvider) {
    localStorageServiceProvider
      .setPrefix('diviac')
      .setStorageType('sessionStorage')
      .setNotify(true, true);

    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false,
    });

    var isDev = _.find(
      ['diviac.inprogress.rocks', '192.168', 'localhost'],
      function (str) {return _.includes(window.location.host, str);}
    );

    $httpProvider.interceptors.push('authHttpResponseInterceptor');
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  });
